import { render, staticRenderFns } from "./sharingAgreement.vue?vue&type=template&id=6e5fbf6c&scoped=true&"
import script from "./sharingAgreement.vue?vue&type=script&lang=js&"
export * from "./sharingAgreement.vue?vue&type=script&lang=js&"
import style0 from "./sharingAgreement.vue?vue&type=style&index=0&id=6e5fbf6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5fbf6c",
  null
  
)

export default component.exports